module.exports = __webpack_public_path__ + "static/media/slide-4.419bfe6d.webp";